import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { authPanelSx } from '../styles/secondaryMsiStyles';

/**
 * Centered, branded card for full-page sign-in steps (invitation, MFA setup).
 * Uses the same brand mark as the Login page so these steps read as one flow.
 */
export function AuthBrandMark() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box aria-hidden="true" sx={{
        width: 38,
        height: 38,
        display: 'grid',
        placeItems: 'center',
        borderRadius: 2,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        fontSize: 20,
        fontWeight: 800,
      }}>A</Box>
      <Typography sx={{ fontSize: 13, fontWeight: 800, letterSpacing: '0.12em' }}>
        ALPHAMIZER
      </Typography>
    </Box>
  );
}

export default function AuthCardShell({ title, subtitle, children }) {
  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      p: { xs: 2, sm: 3 },
      bgcolor: 'background.default',
    }}>
      <Paper elevation={4} sx={{
        ...authPanelSx,
        width: '100%',
        maxWidth: 460,
        p: { xs: 3, sm: 4.5 },
        display: 'grid',
        gap: 2,
      }}>
        <AuthBrandMark />
        <Box sx={{ mt: 1.5 }}>
          <Typography component="h1" sx={{ fontSize: { xs: 26, sm: 29 }, fontWeight: 750, lineHeight: 1.15 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography color="text.secondary" sx={{ fontSize: 14, lineHeight: 1.55, mt: 1 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {children}
      </Paper>
    </Box>
  );
}
